module.exports = __webpack_public_path__ + "img/category-fishing-game-hover.11d3f4d3.png";